import * as actionTypes from "./actionTypes";
import axiosRequest from "../../axios-request/request.methods";

//bi fetched
export const fetchAboutCustomer = (payload) => {
  //console.log(payload)
  return {
    type: actionTypes.FETCH_ABOUT_CUSTOMER,
    formData: payload,
  };
};
// bi started
export const editAboutCustomerStarted = () => {
  // //console.log(formData)
  return {
    type: actionTypes.FETCH_ABOUT_CUSTOMER_START,
  };
};

export const editAboutCustomerSuccess = (formData, succMsg, res) => {
  return {
    type: actionTypes.FETCH_ABOUT_CUSTOMER_SUCESS,
    formData: formData,
    succMsg: "Proposal Updated Successfully",
    response: res,
  };
};

// export const fetchAboutCustomerSuccess = (payload, apiPath) => {
//   return async (dispatch) => {
//     dispatch(editAboutCustomerStarted());
//     axiosRequest.put(apiPath, payload).then((res)=>{
//         //console.log(res);
//         return dispatch(fetchAboutCustomer(res?.AboutCustomer));
//     })
//   };
// };

export const fetchAboutCustomerSuccess = (payload, apiPath) => {
  return async (dispatch) => {
    dispatch(editAboutCustomerStarted());
    try {
      const res = await axiosRequest.put(apiPath, payload);
      dispatch(fetchAboutCustomer(res?.AboutCustomer));
      return res;
    } catch (err) {
      console.error("Error in fetchAboutCustomerSuccess:", err);
      throw err;
    }
  };
};

export const editAboutCustomerFail = (errMsg) => {
  return {
    type: actionTypes.FETCH_ABOUT_CUSTOMER_FAIL,
    error: errMsg,
  };
};
